module.exports = __webpack_public_path__ + "img/hardware.ae17659d.svg";